import { render, staticRenderFns } from "./choice_echo.vue?vue&type=template&id=ab9b5410&scoped=true"
import script from "./choice_echo.vue?vue&type=script&lang=js"
export * from "./choice_echo.vue?vue&type=script&lang=js"
import style0 from "./choice_echo.vue?vue&type=style&index=0&id=ab9b5410&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9b5410",
  null
  
)

export default component.exports